export default "__VITE_PUBLIC_ASSET__b5e94ae4__"